<template>
  <div class="content">
    <section class="page-intro">
      <p>
        <span class="f-ticker">Ongoing</span>
      </p>
      <p class="tag-list">
        <span class="tag icon-text">Personal</span>
      </p>
    </section>

    <!-- Project intro -->
    <section>
      <div class="row">
        <div class="column column-50">
          <h2 class="mt-0">Where we began</h2>
          <p>
            Odyssey approached me under the name 'Agora', recognized that they
            needed not only a new visual identity, but a completely new name. A
            tall order, but I couldn't have been more excited for the
            opportunity.
          </p>
          <p>
            We started this process with a two-week-long discovery process. I
            met with the founders, dove into their business, and took time to
            learn more about the founders themselves. Questions ranged from the
            company's mission all the way to their favorite movies and albums.
          </p>
          <p>
            I was careful to present every name in exactly the same format,
            avoiding any color and keeping the language consistent to reduce
            bias. Countless mockups of each prospective name were presented in
            the forms of everything from business cards to fictional quotes from
            their audience hopefuls.
          </p>
        </div>
      </div>
    </section>

    <!-- Image gallery -->
    <section>
      <div class="row">
        <div class="column">
          <img
            src="@/assets/work/odyssey/NamingCollage.png"
            alt="Typographic scale"
          />
          <img
            src="@/assets/work/odyssey/NamingCollage2.png"
            alt="Typographic scale"
          />
          <img
            src="@/assets/work/odyssey/NamingCollage3.png"
            alt="Typographic scale"
          />
        </div>
      </div>
    </section>

    <!-- Text -->
    <section>
      <div class="row">
        <div class="column column-60">
          <h2 class="mt-0">Enter Odyssey</h2>
          <p>
            After nearly a dozen names, and even more spirited debates, one name
            rose to the top: Odyssey. It captured the ambition of the team, the
            journey they were inviting others to take, and the sense of wonder
            baked into their mission.
          </p>
          <p>
            What sealed it, however, was something much more personal, as is
            often the case. Both co-founders had spent their youth sailing. The
            name struck a chord—not just as a reflection of their own journeys,
            but of the one they hoped to offer others.
          </p>
        </div>
      </div>
    </section>

    <!-- Final image gallery section -->
    <section>
      <div class="row">
        <div class="column">
          <img
            src="@/assets/work/odyssey/OdysseyCover.png"
            alt="Odyssey Cover"
          />
          <img
            src="@/assets/work/odyssey/BrandBookCollage.png"
            alt="Brand Book"
          /><img src="@/assets/work/odyssey/Logos.png" alt="Odyssey Cover" />
          <img
            src="@/assets/work/odyssey/OdysseyPalette.png"
            alt="Odyssey Palette"
          />
          <img
            src="@/assets/work/odyssey/NYPoster_01.png"
            alt="Odyssey Palette"
          />
          <img
            src="@/assets/work/odyssey/Stationery01.png"
            alt="Odyssey Palette"
          />
        </div>
      </div>
    </section>
  </div>
</template>
